(function () {
  const TRACKING_PARAM_KEYS = new Set([
    '_pos',
    '_sid',
    '_ss',
    '_su_rec',
    '_su_rec_id',
    'pr_prod_strat',
    'pr_rec_id',
    'pr_rec_pid',
    'pr_ref_pid',
  ]);

  const CLEANUP_ROOT_SELECTOR = [
    '.custom-search',
    '.custom-search-wrap',
    '#search-modal',
    '.predictive-search',
    '.custom-product-carousel',
    '.product-grid',
    'results-list',
  ].join(', ');

  /**
   * @param {string} urlString
   * @returns {string}
   */
  function stripTrackingParamsFromUrl(urlString) {
    try {
      const url = new URL(urlString, window.location.origin);
      let changed = false;

      TRACKING_PARAM_KEYS.forEach((key) => {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          changed = true;
        }
      });

      if (!changed) return urlString;

      const query = url.searchParams.toString();
      if (query) {
        return `${url.pathname}?${query}${url.hash}`;
      }

      return `${url.pathname}${url.hash}`;
    } catch {
      return urlString;
    }
  }

  /**
   * @param {string} pathname
   * @returns {boolean}
   */
  function isSearchResultsPath(pathname) {
    return pathname === '/search' || pathname.endsWith('/search');
  }

  function cleanSearchPageUrl() {
    const current = new URL(window.location.href);
    if (!isSearchResultsPath(current.pathname)) return;

    const query = current.searchParams.get('q');
    const page = current.searchParams.get('page');

    const clean = new URL(current.pathname, current.origin);
    if (query) {
      clean.searchParams.set('q', query);
    }
    if (page && page !== '1') {
      clean.searchParams.set('page', page);
    }

    const cleanHref = clean.toString();
    if (cleanHref !== current.toString()) {
      history.replaceState(history.state, '', `${clean.pathname}${clean.search}${clean.hash}`);
    }
  }

  function cleanAddressBar() {
    cleanSearchPageUrl();

    const cleaned = stripTrackingParamsFromUrl(window.location.href);
    if (cleaned !== window.location.href) {
      history.replaceState(history.state, '', cleaned);
    }
  }

  /**
   * @param {HTMLAnchorElement} anchor
   */
  function cleanProductAnchor(anchor) {
    if (!anchor.href.includes('/products/')) return;

    const cleaned = stripTrackingParamsFromUrl(anchor.href);
    if (cleaned !== anchor.href) {
      anchor.href = cleaned;
    }
  }

  /**
   * @param {ParentNode} root
   */
  function cleanProductAnchorsIn(root) {
    root.querySelectorAll('a[href*="/products/"]').forEach((node) => {
      if (node instanceof HTMLAnchorElement) {
        cleanProductAnchor(node);
      }
    });
  }

  function cleanScopedAnchors() {
    document.querySelectorAll(CLEANUP_ROOT_SELECTOR).forEach((element) => {
      cleanProductAnchorsIn(element);
    });
  }

  function scheduleCleanups() {
    cleanAddressBar();
    cleanScopedAnchors();
  }

  /**
   * @param {Event} event
   */
  function handleProductLinkClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const anchor = target.closest('a[href*="/products/"]');
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (anchor.target === '_blank') return;

    const cleaned = stripTrackingParamsFromUrl(anchor.href);
    if (cleaned !== anchor.href) {
      anchor.href = cleaned;
    }
  }

  function observeDynamicHrefs() {
    const observer = new MutationObserver(() => {
      cleanScopedAnchors();
    });

    document.querySelectorAll(CLEANUP_ROOT_SELECTOR).forEach((target) => {
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href'],
      });
    });
  }

  function initProductUrlTrackingCleanup() {
    scheduleCleanups();
    window.setTimeout(scheduleCleanups, 250);
    window.setTimeout(scheduleCleanups, 800);
    window.setTimeout(scheduleCleanups, 2000);
    observeDynamicHrefs();
    document.addEventListener('click', handleProductLinkClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductUrlTrackingCleanup);
  } else {
    initProductUrlTrackingCleanup();
  }
})();
